import React from "react";
import { Bet } from "../../../types/Bet";
import { Match } from "../../../types/Match";
import FixtureCard from "./FixtureCard";
import "./FixtureTile.scss";
import FixtureTileDesktop from "./FixtureTileDesktop";

export interface FixtureTileProps {
  match: Match;
  bet: Bet[];
  setCurrentModalMatch: React.Dispatch<React.SetStateAction<Match>>;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isDesktop?: boolean;
}

const FixtureTile: React.FC<FixtureTileProps> = ({
  match,
  bet,
  setCurrentModalMatch,
  setIsOpen,
  isDesktop,
}) => {
  function handleClick(){
    setCurrentModalMatch(match);
    setIsOpen(true);
  }

  if (!isDesktop) {
    return <FixtureCard match={match} bet={bet} onClick={handleClick} />;
  }

  return <FixtureTileDesktop match={match} bet={bet} onClick={handleClick} />;
};

export default FixtureTile;
